import Select from "react-select";
import Modal from 'react-modal';
import { useState } from 'react';

import setLandschapAndPartijen from "../../../noncomponents/setLandschapAndPartijen"

function Landschap({ data, clickSelection, connectionChains, chainSelection,
    landschapOptions, setLandschapOptions }) {

  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  // const [_, nieuweLandschapOptions] = setLandschapAndPartijen(data, connectionChains,
  //   chainSelection, setLandschapOptions, [], false);

  const modalStyle = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#726f6d';
  }

  function handleChange(selection){
    const value = selection.target.value;

    if(!selection.target.checked){
      setLandschapOptions(landschapOptions.filter(landschap => landschap !== value));
    }else{
      setLandschapOptions([...landschapOptions, value]);
    }
  }

  const alleLandschapstypes = [
    'Droogmakerij',
    'Zeekleipolder',
    'Rivierengebied',
    'Dekzandgebied',
    'Stuwwal',
    'Heuvelland',
    'Laagveen',
    'Rivierterrassen',
    'Kust',
    'Keileemgebied',
    'Voormalige hoogvenen'
  ];

  // const question_mark = require("../../../assets/data/images/question-mark.png").default;
  const netherlandsIcon = require("../../../assets/data/images/netherlands.png").default;
  const landschapstypenKaart = require("../../../assets/data/images/landschapstypenkaart.png").default;

  return (
    <div className="Landschap">
      <div style={{ width:'100%', height:'40px' }}>
        {/* <div style={{width:'10%', height:'40px', float:'left', marginLeft:'7%' }} >
          <input
            type='image'
            alt='Klik om alle landschapstypen in Nederland op de kaart te zien'
            src={netherlandsIcon}
            style={{cursor:'pointer'}}
            onClick={() => setIsOpen(true)}
            height='35px'
            title='Landschapstypen aanwezig in de oorzaakrelaties van de geselecteerde impact (icoon in buitenste cirkel) tot aan de binnenste cirkel'
          />
        </div> */}

        <label>{'Landschapstypes '}</label>
        <ul class="ks-cboxtags">
          {alleLandschapstypes.map((landschap,i) => {
            const checked = landschapOptions.includes(landschap);
            const ksSelected = (i === 0) ? 'ks-selected' : ''
            return (
              <li class={ksSelected}>
                <input type="checkbox" id={landschap+i} value={landschap} checked={checked} onChange={handleChange}/>
                <label for={landschap+i}>{landschap}</label>
              </li>
            )
          })}

        </ul>
      </div>



      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        onAfterOpen={afterOpenModal}
        style={modalStyle}
        contentLabel="Dit scherm laat een kaart zien van waar de verschillende landschapstypen in Nederland zich bevinden"
      >
        <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Landschapstypen</h2>
        <button onClick={() => setIsOpen(false)} style={{ position:'absolute', right:'4px', top:'4px' }}>
          Sluiten
        </button>
        <div>
          <img
            src={landschapstypenKaart}
            width='750'
            title='Landschapstypen aanwezig in de oorzaakrelaties van de geselecteerde impact (icoon in buitenste cirkel) tot aan de binnenste cirkel'
            alt='Landschapstypenkaart van Nederland'
          />
        </div>

      </Modal>

    </div>



  );
}

export default Landschap;
